import { useEffect } from "react";
import { HeroHeader } from "../../components/HeroHeader";
import { Stack } from "../../components/Stack";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import "../HomePage/style.css";
import "./style.css";
import { Button } from "../../components/Button";
import { initFadeInAnimation } from "../../animation";
import { useSelector } from "react-redux";
import {
  selectAllApartments,
  selectAllContent,
  selectIsLoading,
} from "../../features/apartments/selectors";
import { TextImage } from "../../components/TextImage";
import { aboutUsContent } from "../../constants/constants";
import { useTranslation } from "react-i18next";
import { imagesResponse } from "../../api/responses";
import { Loader } from "lucide-react";
import { Seo } from "../../components/Seo";
import { PageShell } from "../../components/PageShell";
import { useInitApp } from "../../hooks/useInitApp";
import { BOOKING_URL } from "../../constants/links";

gsap.registerPlugin(ScrollTrigger);

export const AboutUs = () => {
  const content = useSelector(selectAllContent);
  const { t } = useTranslation();
  const data = useSelector(selectAllApartments);
  const isLoading = useSelector(selectIsLoading);

  useInitApp();

  useEffect(() => {
    if (isLoading) return;
    initFadeInAnimation(".fade-in");
  }, [isLoading]);

  const hasData = (data?.length ?? 0) > 0;
  if (isLoading && !hasData) return <Loader />;
  if (!hasData) return <Loader />;

  return (
    <>
      <Seo
        title="Chi siamo"
        description="Scopri Isola Dei Mori, la nostra storia e l'ospitalità a Sant'Antioco."
      />
      <PageShell>
      <HeroHeader
        title={t("about-us-title")}
        imgSrc={content?.[6]?.url || imagesResponse[4].url}
        className="fade-in"
      />
      <Stack flexDirection="column">
        <div className="first-home">
          <div className="text-container-centered">
            <h1 className="fade-in">{t("about-us-title")}</h1>
            <div className="description-first-home ">
              <span className="fade-in">{t("about-us-1")}</span>
              <span className="fade-in">{t("about-us-2")}</span>
              <span className="fade-in">{t("about-us-3")}</span>
            </div>
          </div>
          <Stack className="button-group">
            <Button
              buttonTitle={t("discover-btn")}
              icon="ArrowForwardIosRounded"
              fontSize="md"
              className="button-home-book fade-in"
              onClick={() =>
                window.open(BOOKING_URL)
              }
            />
          </Stack>
        </div>
        <Stack
          flexDirection="column"
          gap={50}
          paddingvertical={50}
          className="second-about"
          flex={1}
        >
          {aboutUsContent?.map((_, index) => {
            return (
              <TextImage
                description={t(
                  `about-us-content.content-${index + 1}-description`
                )}
                title={t(`about-us-content.content-${index + 1}-title`)}
                imageSrc={content?.[index]?.url || imagesResponse[4].url}
                direction={index % 2 === 0 ? "row" : "reverse"}
                key={index}
              />
            );
          })}
        </Stack>
      </Stack>
      </PageShell>
    </>
  );
};
